export const isFormValid = form => {
    return !!(
        form.firstName &&
        form.lastName &&
        form.personalMail &&
        form.password &&
        form.platformName &&
        form.platformUrl
    )
}
